import { Box, Chip, FormControl, MenuItem, Select, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import dayjs from 'dayjs';
import { GetPriorityColor, PriorityColor } from '../../../constants/colors';
import { Todo } from '../../../types/types';
import { getDueStatus } from '../utils/statusUtils';

interface StatusPrioritySectionProps {
    isEditing: boolean;
    todo: Todo;
    editedPriority: string;
    setEditedPriority: (value: 'low' | 'medium' | 'high') => void;
}

export const StatusPrioritySection = ({
    isEditing,
    todo,
    editedPriority,
    setEditedPriority
}: StatusPrioritySectionProps) => {
    return (
        <Stack direction="row" spacing={3} sx={{ mb: 3 }}>
            <Box flex={1}>
                <Typography color="text.secondary" variant="subtitle2" gutterBottom>
                    Status
                </Typography>
                <StatusChip todo={todo} />
            </Box>
            <Box flex={1}>
                <Typography color="text.secondary" variant="subtitle2" gutterBottom>
                    Priority
                </Typography>
                {isEditing ? (
                    <FormControl
                        fullWidth
                        size="small"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Select
                            value={editedPriority}
                            onChange={(e) => {
                                e.stopPropagation();
                                setEditedPriority(e.target.value as 'low' | 'medium' | 'high');
                            }}
                            onClick={(e) => e.stopPropagation()}
                            onMouseDown={(e) => e.stopPropagation()}
                            onMouseUp={(e) => e.stopPropagation()}
                            sx={{ bgcolor: 'background.paper' }}
                        >
                            <MenuItem
                                value="low"
                                onClick={(e) => e.stopPropagation()}
                            >
                                Low
                            </MenuItem>
                            <MenuItem
                                value="medium"
                                onClick={(e) => e.stopPropagation()}
                            >
                                Medium
                            </MenuItem>
                            <MenuItem
                                value="high"
                                onClick={(e) => e.stopPropagation()}
                            >
                                High
                            </MenuItem>
                        </Select>
                    </FormControl>
                ) : (
                    <PriorityChip priority={todo.priority} />
                )}
            </Box>
        </Stack>
    );
};

const StatusChip = ({ todo }: { todo: Todo }) => {
    const status = getDueStatus(todo.completed, todo.dueDate ? dayjs(todo.dueDate) : undefined);
    return (
        <Chip
            label={status.label}
            sx={{
                bgcolor: status.color,
                color: 'white',
                fontWeight: 'medium'
            }}
            size="small"
        />
    );
};

const PriorityChip = ({ priority }: { priority: string }) => {
    const theme = useTheme();
    return (
        <Chip
            label={priority}
            sx={{
                bgcolor: GetPriorityColor(theme)[priority as PriorityColor],
                color: 'white',
                fontWeight: 'medium'
            }}
            size="small"
        />
    );
}; 